export default "assets/line-sm-ee53b55f.svg";